var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.dropDownItemClass,attrs:{"href":_vm.refreshTokenLoading ? '#' : _vm.url}},[_c('i',{class:("nc-icon " + _vm.icon + " app-icon")}),_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }